<script setup></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
  >
    <path
      fill-rule="nonzero"
      d="M12 0v10h10v2H12v10h-2V12H0v-2h10V0h2Z"
    />
  </svg>
</template>

<style lang="scss" scoped></style>
